<ng-container *ngIf="userInfo?.scopes.includes('SALESREP_PRIVILEGE')">
  <div class="my-3">
    <div class="card">
      <div class="card-body">
        <form #details="ngForm">
          <div class="row">
            <div class="form-group col-md-4">
              <label class="star">Ventures</label>
              <select type="text" class="form-control" id="ventures" name="ventures" required
                [(ngModel)]="ventureSelected">
                <option [value]="'all'">All Ventures</option>
                <option *ngFor="let venture of ventures" [value]="venture.ventureId">{{venture.ventureName}}</option>
              </select>
            </div>
            <div class="col-md-2 mt-4" style="font-size: medium;">
              <button class="btn-info py-1 px-3 border rounded" (click)="getCommissionsByVenture()"
                [disabled]=details.invalid><b>Go</b></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<div class="my-3">
  <div class="card">
    <div class="card-body">
      <h6 class="card-title text-dark position-relative pb-2 h6">Direct Commission</h6>
      <!-- <app-direct-commission [id]="venture" [sales] = sale></app-direct-commission> -->
      <div class="wrap">
        <table class="table table-striped table-bordered table-sm row-border hover">
          <thead>
            <tr>
              <th>Venture Name</th>
              <th>Plot Number</th>
              <th>Plot Status</th>
              <th>Total Commission(<i class="fas fa-rupee-sign"></i>)</th>
              <th>Commission Earned(<i class="fas fa-rupee-sign"></i>)</th>
              <th *ngxPermissionsOnly="[userPrivileges.MARKETER_SUPER_PRIVILEGE,userPrivileges.MARKETER_BASIC_PRIVILEGE, userPrivileges.TENANT_PRIVILEGE,userPrivileges.TENANT_BASIC_PRIVILEGE] ">
                Commission Paid(
                <i class="fas fa-rupee-sign"></i>)
              </th>
              <th *ngxPermissionsOnly="[userPrivileges.SALESREP_PRIVILEGE]">Commission Received(<i
                  class="fas fa-rupee-sign"></i>)</th>
              <th>Commission Pending(<i class="fas fa-rupee-sign"></i>)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let commission of directComm">
              <td>{{commission.ventureName}}</td>
              <td (click)="display(commission)">{{commission.plotNumber}}</td>
              <td>{{commission.plotStatus | titlecase}}</td>
              <td>{{commission.totalCommission?.toLocaleString('en-IN')}}</td>
              <td>{{commission.commissionEarned?.toLocaleString('en-IN')}}</td>
              <td>{{commission.commissionPaid?.toLocaleString('en-IN')}}</td>
              <td>{{commission.commissionPending?.toLocaleString('en-IN')}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div>
  <div class="card">
    <div class="card-body">
      <h6 class="card-title text-dark position-relative pb-2 h6">Indirect Commission</h6>
      <!-- <app-indirect-commission [id]="venture" [sales] = sale></app-indirect-commission> -->
      <div class="wrap">
        <table class="table table-striped table-bordered table-sm row-border hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Venture Name</th>
              <th>Plot Number</th>
              <th>Plot Status</th>
              <th>Total Commission(<i class="fas fa-rupee-sign"></i>)</th>
              <th>Commission Earned(<i class="fas fa-rupee-sign"></i>)</th>
              <th *ngxPermissionsOnly="[userPrivileges.MARKETER_SUPER_PRIVILEGE,userPrivileges.MARKETER_BASIC_PRIVILEGE, userPrivileges.TENANT_PRIVILEGE,userPrivileges.TENANT_BASIC_PRIVILEGE] ">
                Commission Paid(
                <i class="fas fa-rupee-sign"></i>)
              </th>
              <th *ngxPermissionsOnly="[userPrivileges.SALESREP_PRIVILEGE]">Commission Received(<i
                  class="fas fa-rupee-sign"></i>)</th>
              <th>Commission Pending(<i class="fas fa-rupee-sign"></i>)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let commission of indirectComm">
              <td>{{commission.salesrepName}}</td>
              <td>{{commission.ventureName}}</td>
              <td (click)="display(commission)">{{commission.plotNumber}}</td>
              <td>{{commission.plotStatus | titlecase}}</td>
              <td>{{commission.totalCommission?.toLocaleString('en-IN')}}</td>
              <td>{{commission.commissionEarned?.toLocaleString('en-IN')}}</td>
              <td>{{commission.commissionPaid?.toLocaleString('en-IN')}}</td>
              <td>{{commission.commissionPending?.toLocaleString('en-IN')}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>